import Title from "@/components/common/Typography/Title"
import { Row } from "antd"
import { TitleProps } from "antd/es/typography/Title"
import { FC } from "react"

type HotelNameProps = TitleProps & {
  name?: string
}

const HotelName: FC<HotelNameProps> = ({ name = "", ...props }) => {

  return (
    <Row style={{ maxWidth: '100%' }}>
      <Title
        level={5}
        {...props}
        className={`hotels__list--item-title${props.className ? ` ${props.className}` : ""}`}
        style={{ marginBlock: 0, ...props.style }}
      >
        {name}
      </Title>
    </Row>
  )
}

export default HotelName